import { ComponentPropsWithoutRef, useEffect, useRef } from 'react';

import * as S from './styles';

const LinkBlob = ({ children, ...props }: ComponentPropsWithoutRef<'a'>) => {
  const ref = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    ref.current?.click();
  }, [ref]);

  return (
    <S.LinkBlob ref={ref} as="a" {...props}>
      {children}
    </S.LinkBlob>
  );
};

export default LinkBlob;
